export default __webpack_public_path__ + "2006d2b30f2bbc4f175be7c1b21dff8c.png";